(function(){
    class GWP {
        atcCallback = [];
        cart = window._theme.cartjson;
        enable = window._theme.gwp.enable;     
        #freeProducts = window._theme.gwp?.freeProducts || [];
        #excludeTags = window._theme.gwp?.excludeTags || [];
        #excludeProductTypes = window._theme.gwp?.excludeProductTypes || [];
        #cartExtended = window._theme.gwp.cartExtended || [];
        #gwp2AutoATC = window._theme.gwp.gwp_2_auto_add || false;
        gwpType = window._theme.gwp.type || "gwp_1";
        propName = window._theme.gwp.type === "gwp_1" ? '_smgift' : '_gwp';
        isCartOrCheckoutPage = document.querySelector('body.cart') ? true : false;

        constructor(){
            if(this.#excludeTags.length) this.#excludeTags = this.#excludeTags.map(tag => tag.trim());
            if(this.#excludeProductTypes.length) this.#excludeProductTypes = this.#excludeProductTypes.map(type => type.trim());
            
            const PRE_ORDER_STEPS = ['contact_information', 'shipping_method', 'payment_method'];
            const checkoutStep = window.Shopify && Shopify.Checkout && Shopify.Checkout.step;
            if(checkoutStep && PRE_ORDER_STEPS.includes(checkoutStep)) this.isCartOrCheckoutPage = true;
            this.#freeProducts.reverse();
            delete window._theme.gwp;
        }

        /** 
         * Check if offer is enable in the customize settings
        */
        isEnable(){
            if(!this.enable || this.#freeProducts.length === 0) return false;
            return true;
        }

        /***
         * Check if gift product is already added to the cart
         */
        isGiftProductAdded(){
            const giftLineItems = [];
            if(!this.cart || this.cart.item_count === 0) return giftLineItems;

            this.cart.items.forEach((item, index) => {
                if(item.properties && item.properties[this.propName]){
                    item['lineIndex'] = index + 1;
                    giftLineItems.push(item)
                }
            });

            return giftLineItems;
        }

        /** 
         * check if the user can avail this offer
         * if cart total amount is greater than or equal to minimum required amount
        */
        async validate(cart){
            if(!cart) {
                //throw Error('Invalid cart');
                await this.updateData();
            }

            let isEnable = this.isEnable();
            let status = false;
            if(this.cart.item_count === 0) return { status, giftLineItems: [], matchedProducts: [] };

            const giftLineItems = this.isGiftProductAdded();
            let cart_total_price = this.cart.total_price;
            
            if(giftLineItems.length) {
                giftLineItems.forEach(item => {
                    cart_total_price -= item.final_line_price;
                });
            }
            
            if(this.#excludeTags.length || this.#excludeProductTypes.length){
                this.#cartExtended.forEach(lineItem => {
                    const tags = lineItem.tags || [];
                    const lineType = lineItem.product_type || '';
                    const hasTag = tags.some(tag => this.#excludeTags.includes(tag));
                    const hasType = this.#excludeProductTypes.includes(lineType);
                    if(hasTag || hasType) cart_total_price -= lineItem.final_line_price;
                });
            }

            cart_total_price /= 100;

            const matchedProducts = this.#freeProducts.filter( ({ min_amt, product_vid }) => (cart_total_price >= min_amt && product_vid));
            const finalMatchedProducts = matchedProducts.filter( ({ product_vid }) => !this.cart.items.some(({variant_id}) => variant_id === product_vid));
            
            if(matchedProducts.length) status = true;
            if(!isEnable) status = false;

            return {
                status, 
                giftLineItems,
                matchedProducts,
                finalMatchedProducts
            };
        }

        updateData = async () => {
            const data = await GWP.getCart();
            this.cart = data.cart;
            this.enable = data.gwp_enable;
            this.#cartExtended = data.cartExtended || [];
            this.#excludeTags = data.excludeTags || [];
            this.#excludeProductTypes = data.excludeProductTypes || [];
            this.#freeProducts = data.freeProducts || [];
            this.gwpType = data.type || "gwp_1";
            this.#freeProducts.reverse();

            if(this.#excludeTags.length) this.#excludeTags = this.#excludeTags.map(tag => tag.trim());
            if(this.#excludeProductTypes.length) this.#excludeProductTypes = this.#excludeProductTypes.map(type => type.trim());
            
            return true;
        }

        /**
         * Run validation on load
         * update cart
         */
        async runInitialValidation(){
            try {
                await this.updateData();
                if(this.enable) this.run(true);
            } catch(err){
                console.error(err);
            }
        }

        /**
         * this method will add/remove free product
         */
        async run(runAsInitial, element, cart){
            let isCartUpdated = false, newCart = cart;

            try {
                if(cart) this.cart = cart;
                if(!runAsInitial && !cart) await this.updateData();
                const result = await this.validate(this.cart);
                
                if(element) this.activeElement = element;

                if(result.status && result.giftLineItems.length){
                    const invalidGiftitems = result.giftLineItems.filter(item => {
                        return result.matchedProducts.every(product => product.product_vid !== item.variant_id)
                    });

                    if(invalidGiftitems.length){
                        _theme.toggleCartLoading(true);
                        const variant_ids = invalidGiftitems.map(item => item.variant_id);
                        newCart = await this.removeGiftProductFromCart2(variant_ids);
                        isCartUpdated = true;
                        delete result.giftLineItems;
                    }
                }
                
                if(this.gwpType === "gwp_1" || this.#gwp2AutoATC){
                    // GWP enable & gift product is not added yet
                    // && (!result.giftLineItems || result.giftLineItems.length === 0)
                    if(result.status && result.finalMatchedProducts.length){
                        _theme.toggleCartLoading(true);
                        await this.addGiftProductToCart(result.finalMatchedProducts.map(({product_vid}) => product_vid));
                        const updatedCart = await GWP.getCart();
                        newCart = updatedCart.cart;
                        isCartUpdated = true;
                    }    
                }

                // GWP disable & Cart has free gift product then remove
                if(!result.status && result.giftLineItems && result.giftLineItems.length){
                    _theme.toggleCartLoading(true);
                    const variant_ids = result.giftLineItems.map(item => item.variant_id);
                    newCart = await this.removeGiftProductFromCart2(variant_ids);
                    isCartUpdated = true;
                }
                
                // Run Registered Callbacks
                if(this.atcCallback.length){
                    this.atcCallback.forEach(fn => {
                        fn(newCart);
                    });
                }
                
                // Run On Initial Load
                if(runAsInitial){
                    if(!newCart.status && isCartUpdated){
                        if(this.isCartOrCheckoutPage) {
                            window.location.reload();
                        } else {
                            // await _theme.refreshCart();                        
                        }
                    }

                    if(!this.isCartOrCheckoutPage) _theme.refreshCart();

                    _theme.toggleCartLoading(false);
                }

                this.cart = newCart;
                _theme.cartjson = newCart;
        
                return {
                    cart: newCart,
                    isCartUpdated: isCartUpdated
                };
            } catch(err){
                console.error(err);
                return {
                    cart: newCart,
                    isCartUpdated: isCartUpdated
                }
            }
        }

        /**
         * It accept callback function
         * Callback function will be registered
         * Callbacks method will invoke inside "run" method & after cart updated
         */
        static registerATCCallBack(fn){
            if(!fn || typeof fn !== 'function') throw Error('Cannot register callback, Argument type is Invalid');
            this.atcCallback.push(fn);
        }
        
        /**
         * @returns cart json
         */
        static getCart(){
            return fetch('/cart?view=offer').then(res => res.json()).then(cart => cart);
        }

        /**
         * 
         * @param {*} data 
         * @returns ajax request header with stringify body property
         */
        #getAjaxHeaders(data){
            return {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(data)
            }
        }

        /**
         * Add free product to cart &
         * @returns updated cart object
         */
        async addGiftProductToCart(product_vids = []){
            if(!Array.isArray(product_vids) || product_vids.length === 0) throw Error('Invalid variant id');
            
            try {
                const items = product_vids.map(vid => (
                    { 
                        'id': vid, 
                        'quantity': 1,  
                        "properties" : { 
                            [this.propName]: 1  
                        }
                    }
                ));
                
                const resp = await fetch('/cart/add.js', this.#getAjaxHeaders({items}));
                const lineItem = await resp.json();
                return lineItem;
            } catch(err){
                return err;
            }
        }

        /**
         * Remove free product from cart &
         * @returns updated cart object
         */
        async removeGiftProductFromCart(formData){
            if(!formData) throw Error('Invalid form data');
            
            try {
                const res = await fetch('/cart/change.js', this.#getAjaxHeaders(formData))
                const cart = await res.json();
                return cart;
            } catch(err){
                return err;
            }
        }

        /**
         * 
         * @param {Array} lineIds 
         */
        async removeGiftProductFromCart2(lineIds){
            if(lineIds.length === 0) return;

            try {
                const updates = {};
                lineIds.forEach(vid => {
                    updates[vid] = 0;
                });
                
                const res = await fetch('/cart/update.js', this.#getAjaxHeaders({updates}))
                const cart = await res.json();
                return cart;
            } catch(err){
                return err;
            }
        }
    }

    class GWPModal extends HTMLElement {
        constructor(){
            super();

            this.activeBtn = null;
            this.cartItem = null;
            this.showModal = this.showModal.bind(this);
            this.hideModal = this.hideModal.bind(this);
            this.handleAddToCart = this.handleAddToCart.bind(this);
            this.isCartPage = document.querySelector('body.page--cart');

            this.buildSelectors();
            
            _theme.gwpBar = this;
            this.amounts = this.dataset.amounts.split(',').map(amt => Number(amt));
        }

        connectedCallback(){
            if(this.modalOpenerBtn) this.modalOpenerBtn.addEventListener('click', this.showModal);
            if(this.modalCloseBtn) this.modalCloseBtn.addEventListener('click', this.hideModal);
            if(this.modalBack) this.modalBack.addEventListener('click', this.hideModal);

            this.atcBtns.forEach(btn => {
                btn.addEventListener('click', evt => {
                    this.activeBtn = btn;
                    const vid = btn.dataset.vid;
                    if(!vid) return;

                    this.handleAddToCart(vid);
                }, {once: true})
            });

            this.removeAtcBtns.forEach(btn => {
                btn.addEventListener('click', evt => {
                    this.activeBtn = btn;
                    const lineId = btn.dataset.lineId;
                    if(!lineId) return;

                    this.handleRemoveFromCart(lineId);
                }, {once: true})
            });
        }

        disconnectedCallback() {
            if(this.modalOpenerBtn) this.modalOpenerBtn.removeEventListener('click', this.showModal);
            if(this.modalCloseBtn) this.modalCloseBtn.removeEventListener('click', this.hideModal);
        }

        buildSelectors(){
            this.modalBack = this.querySelector('.gwp-modal-back');
            this.modal = this.querySelector('dialog');
            this.modalOpenerBtn = this.querySelector('.gwp-bar button');
            this.modalCloseBtn = this.querySelector('dialog .gwp-modal-header button');
            this.atcBtns = this.querySelectorAll('dialog .gwp-modal-item-cta button[data-selected="false"]');
            this.removeAtcBtns = this.querySelectorAll('dialog .gwp-modal-item-cta button[data-selected="true"]');
            this.srStatus = this.querySelector('#gwp-modal-sr-status');
        }

        showModal(){
            if(!this.modal) return;

            this.setAttribute('open', true);
            this.modal.setAttribute('aria-hidden', false);
            this.modal.removeAttribute('tabindex');

            if(this.isCartPage) document.body.classList.add('overflow-hidden');

            _theme.focusTrap($(this.modal), (sourceElem, evt) => {
                evt.stopPropagation();
                evt.stopImmediatePropagation();
                this.hideModal();
            });
        }

        hideModal(){
            if(!this.modal) return;

            this.removeAttribute('open');
            this.modal.setAttribute('aria-hidden', true);
            this.modal.setAttribute('tabindex', -1);
            if(this.isCartPage) document.body.classList.remove('overflow-hidden');
            if(this.modalOpenerBtn) this.modalOpenerBtn.focus();
        }

        async handleAddToCart(vid){
            this.showLoader();
            await  _theme._GWP.addGiftProductToCart([vid]);

            if(this.isCartPage) {
                const cart = await this.getCart();
                _theme.refreshCart(cart, {quantity: 1});
            } else {
                _theme.refreshCart();
            }
        }

        async handleRemoveFromCart(lineId){
            this.showLoader();
            const formData = { "id": lineId, "quantity": 0 };
            await  _theme._GWP.removeGiftProductFromCart(formData);

            if(this.isCartPage) {
                const cart = await this.getCart();
                _theme.refreshCart(cart, {quantity: 0});
            } else {
                _theme.refreshCart();
            }
        }

        showLoader(){
            if(!this.activeBtn) return;

            this.activeBtn.classList.add('loading');
            this.srStatus.textContent = "Content loading";
        }

        hideLoader(){
            if(!this.activeBtn) return;

            this.activeBtn.classList.remove('loading');
            this.srStatus.textContent = "Content loaded successfully";
            this.activeBtn = null;

            setTimeout(() => {
                this.srStatus.textContent = "";
            }, 500)
        }

        async render(cart, hideModal){
            const lowestTargetAmt = Math.min.apply(null, this.amounts);
            const highestTargetAmt = Math.max.apply(null, this.amounts);
            if(!cart || lowestTargetAmt === 0 || highestTargetAmt === 0) return;

            // Update cart data
            _theme._GWP.cart = cart;
            _theme.cartjson = cart;

            // Update bar width
            const subTotalAmt = (cart.total_price / 100); // items_subtotal_price
            let progress = ((subTotalAmt * 100) / highestTargetAmt).toFixed(2);
            progress = progress > 100 ? 100 : progress;
            this.style.setProperty('--gwp-progress', `calc(${progress}% - 2px)`);

            // Toggle modal opener button
            const isEligible = (subTotalAmt < lowestTargetAmt) ? false : true;
            if(this.modalOpenerBtn) this.modalOpenerBtn.setAttribute('aria-hidden', !isEligible);

            if(hideModal){
                this.hideLoader();
                this.hideModal();
            }

            // const form = document.querySelector('body div.cart_content.mini-cart form');
            // if(form) form.style.setProperty('--gwp-height', isEligible ? '212px' : '186px');
        }

        /**
         * @returns cart json
         */
        async getCart(){
            return fetch('/cart.js').then(res => res.json()).then(cart => cart);
        }
    }

    customElements.define('gwp-modal', GWPModal);

    _theme._GWP = new GWP();
})();